<template>
    <div class="middle-message">
        <img class="back-image"
            :src="newBgImage">
        <div v-if="isShowImageLogo"
            class="image-honor">
            <img src="static/image/messageLogoNew.png"
                alt="">
        </div>
        <div v-if="isBrowserEnv&&isShowGo"
            class="title">
            <Button @click="goHonorMkt">{{ btnText }}</Button>
        </div>
        <!-- 引导使用浏览器扫码打开 -->
        <guideDialog ref="guideDialog"></guideDialog>
    </div>
</template>
<script>
import { Dialog, Toast } from 'vant';
import { CoordinateType } from '../runtime/lucky-draw/common/global-variable';
import { AMapGetLocation } from '../runtime/TMap.js';
import { config } from '../../../api/config';
import { getJumpLinkUrlInterface, getImageUrlData } from '../../../commons/config.js';
import { getEnvMark } from '../../vibrantRubikCube/runtime/common-methods/utils';
import { EnvMark } from '../runtime/lucky-draw/common/global-variable.js';
import guideDialog from './guideDialog';
import utils from '../../../utils/comUtils.js';
export default {
  components: {
    guideDialog,
  },
  data() {
    return {
      btnText: '点击前往',
      positionInfo: {
        longitude: '',
        latitude: '',
      },
      // 是否是浏览器环境
      isBrowserEnv: false,
      isShowGo: false,
      fullUrl: '',
      showGuide: false,
      // DPlink地址,现在改成接口返回的downloadUrl就是PC端的deeplink配置的地址
      jumpLinkUrl: 'honormarket://details?id=com.tencent.tmgp.trssj&channelInfo=gm30002|v=3|pg=gamewall|ssd=02',
      nearStoreName: '', // 最近的门店名称
      nearStoreCode: '', // 最近的门店编码
      deviceSystem: '', // 当前手机系统
      timer: null,
      bgImage: {
        backgroundImage: `url('/hd/static/img/messageBg.d22af4f.png')`,
      },
      // 背景图改成图片显示
      newBgImage: '/hd/static/img/messageBg.d22af4f.png',
      httpDownloadUrl: '', //跳转的deeplink不可跳转（应用不存在或跳转deeplink存在问题）则停留在当前页面，单击“点击前往”时则获取配置的http下载链接跳转到相应的地址
      attachmentPo: {}, //跳转中转图的图片信息
      isShowImageLogo: false,
    };
  },
  async created() {
    const curEnv = getEnvMark();
    console.log('获取当前H5所处的环境标识', curEnv);
    console.log('获取当前手机系统', this.$browser.versions);
    if (this.$browser.versions.ios || this.$browser.versions.iPhone || this.$browser.versions.iPad) {
      this.deviceSystem = 'IOS';
      Toast('仅支持安卓用户');
      return false;
    } else {
      this.deviceSystem = 'Android';
    }
    // 仅支持手机浏览器扫码，如果使用微信等扫码，给出使用浏览器扫码指引
    if (curEnv !== EnvMark.otherBrowser) {
      this.isBrowserEnv = false;
      this.$nextTick(() => {
        this.$refs.guideDialog.openModel();
      });
    } else {
      this.isBrowserEnv = true;
      try {
        Toast.loading({
          message: '跳转中...',
          forbidClick: true,
        });
        this.positionInfo = await AMapGetLocation();
        console.log('当前的位置信息：this.positionInfo', this.positionInfo);
        Toast.clear();
      } catch (err) {
        console.error(err);
        Toast.clear();
      }
      const routeQuery = this.$route.query;
      if (routeQuery) {
        await this.getLinkUrl(routeQuery.id);
      }
    }
  },
  methods: {
    // 游戏墙扫码后获取跳转的游戏链接URL
    getLinkUrl(routerId) {
      if (routerId) {
        const axios = require('axios');
        const param = {
          method: 'get',
          url: getJumpLinkUrlInterface() + routerId,
        };
        axios(param)
          .then(async (response) => {
            if (response.data) {
              this.jumpLinkUrl = response.data.data.downloadUrl || '';
              this.httpDownloadUrl = response.data.data.httpDownloadUrl || '';
              this.attachmentPo = response.data.data.attachmentPo || {};
              await this.getTransferImage(this.attachmentPo);
              this.queryStoreIn50Km(this.jumpLinkUrl);
            } else {
              await this.getTransferImage(this.attachmentPo);
              this.queryStoreIn50Km(this.jumpLinkUrl);
            }
          })
          .catch((error) => {
            // 默认荣耀应用市场跳转链接
            this.queryStoreIn50Km(this.jumpLinkUrl);
            console.error(error, '游戏墙跳转error');
          });
      } else {
        Dialog.alert({
          message: '获取二维码失败！',
        });
      }
    },
    getTransferImage(attachmentPo) {
      if (attachmentPo.downloadUrl) {
        this.isShowImageLogo = false;
        const downPath = getImageUrlData() + `?path=${attachmentPo.downloadUrl}`;
        this.bgImage = { backgroundImage: `url('${downPath}')` };
        this.newBgImage = downPath;
        console.log('打印图片信息1', this.newBgImage, this.bgImage);
      } else {
        this.isShowImageLogo = true;
        this.bgImage = { backgroundImage: `url('/hd/static/img/messageBg.d22af4f.png')` };
        this.newBgImage = '/hd/static/img/messageBg.d22af4f.png';
        console.log('打印图片信息2', this.newBgImage, this.bgImage, this.isShowImageLogo);
      }
    },
    // 查询附近50km内的门店，默认返回的第1条数据最近
    queryStoreIn50Km(jumpLinkUrl) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const params = {
        coordinateType: this.positionInfo.coordinateType, // 对接高德地图js api，1：wgs84大地坐标系、2：gcj02火星坐标系、3：bd09百度坐标系
        longitude: this.positionInfo.longitude,
        latitude: this.positionInfo.latitude,
        regionalImageLevelCodes: ['honor.life', 'honor.hesh', 'honor.partneredhes', 'honor.county', 'honor.brand', 'honor.flagship', 'level.service.shop'],
        range: 50000,
      };
      this.$api.post({
        noLoading: true,
        sc: 'sms',
        url: config.getNearByStore,
        params: params,
        success: (res) => {
          Toast.clear();
          if (res.status === 'success' || res.code === 'errorcode.success') {
            this.nearStoreCode = (res.result && res.result[0] && res.result[0].storeCode) || '';
            this.nearStoreName = (res.result && res.result[0] && (res.result[0].storeShortName || res.result[0].storeName)) || '';
            // 根据配置链接跳转，若有最近门店编码则拼接上
            this.fullUrl = `${jumpLinkUrl}|pos=${this.nearStoreCode}`;
            this.handleReport();
            this.openApp();
          } else {
            Dialog.alert({
              message: res.message,
            });
          }
        },
        failure: () => {
          Toast.clear();
          Dialog.alert({
            message: '查询失败，请再次扫码后重试！',
          });
        },
      });
    },
    // 跳转荣耀应用市场，此处理用于自动跳转到荣耀应用市场app时部分浏览器不支持，需要增加按钮点击去触发跳转
    // 现在改成4. 若跳转的deeplink不可跳转（应用不存在或跳转deeplink存在问题）则停留在当前页面，单击“点击前往”时则获取配置的http下载链接跳转到相应的地址
    goHonorMkt() {
      this.openHttpUrl();
    },
    // 获取配置的http下载链接跳转到相应的地址
    openHttpUrl() {
      console.log('游戏墙跳转httpUrl', this.httpDownloadUrl);
      window.location.href = this.httpDownloadUrl;
    },
    // 打开荣耀应用市场，若无安装该app，5秒后给出提示
    openApp() {
      console.log('游戏墙跳转最终deeplink', this.fullUrl);
      const start = new Date().getTime();
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        const end = new Date().getTime();
        console.log('start和end相减为', end - start);
        // 如果在5秒内没有跳转到应用，说明应用未安装
        if (end - start >= 5000) {
          Toast('若未跳转，请确认是否安装相关应用？');
          this.isShowGo = true;
        }
      }, 5000);
      this.isShowGo = false;
      window.location.href = this.fullUrl;
    },
    // 埋码上报
    handleReport() {
      const params = {
        ac: 'HSEM',
        actionCode: '850400004',
        actionName: 'SAP场景用户体验_DP拉起页面',
        content: {
          scene: '',
          device_system: this.deviceSystem,
          storeCode: this.nearStoreCode,
          storeName: this.nearStoreName,
          dp_url: this.jumpLinkUrl,
        },
      };
      utils.handleBatchReport(this, params);
    },
  },
};
</script>
<style scoped lang="scss">
.middle-message {
  width: 100vw;
  height: 100vh;
  position: relative;
  // background-image: url('../../../../static/image/messageBg.png');
  // background-size: 100% 100%;
  // background-repeat: no-repeat;
  // background-attachment: scroll;
  overflow: auto;
  .back-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: auto;
    z-index: 1;
  }
  .image-honor {
    width: 26.667vw;
    height: 26.667vw;
    z-index: 100;
    position: fixed;
    left: 50%;
    top: 32%;
    transform: translate(-50%, -50%);
    img {
      width: 26.667vw;
      height: 26.667vw;
    }
  }
  .title {
    width: 100%;
    font-family: HONORSansBrand-Regular;
    font-size: 4.8vw;
    letter-spacing: 0;
    font-weight: 400;
    position: fixed;
    text-align: center;
    bottom: 20px;
    z-index: 100;
  }
  .ivu-btn {
    background: #256fff;
    border-radius: 55px;
    color: #ffffff;
    border: 0 !important;
    padding: 6px 20px;
    font-size: 4.8vw;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/scanGameWallLocate/scanGameWallLocate.vue